




















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Comment } from '@/api/model/comment'

@Component
export default class ColumnPipeline extends Vue {
    @Prop({ required: true }) referral!: Referral

    filterComments(referral: Referral) {
        return referral.comments
            .filter(comment => comment instanceof Comment)
            .sort((a: Comment, b: Comment) => a.createdAt > b.createdAt ? -1 : 1)
    }
}
